import { apiGet, apiPost } from "./axiosClient";
import type {
  AgoraChatToken,
  ConnectSession,
  DailyVideoCredentials,
  VideoJoinResponse,
} from "@/types/domain";

export const getSession = (appointmentId: string) =>
  apiGet<ConnectSession>(`/api/connect/appointments/${appointmentId}/session`);

export const getChatToken = (appointmentId: string) =>
  apiPost<AgoraChatToken>(
    `/api/connect/appointments/${appointmentId}/chat/token`,
  );

export const startVideo = (appointmentId: string) =>
  apiPost<DailyVideoCredentials>(
    `/api/connect/appointments/${appointmentId}/video/start`,
  );

export const joinVideo = (appointmentId: string) =>
  apiPost<VideoJoinResponse>(
    `/api/connect/appointments/${appointmentId}/video/join`,
  );

export const endVideo = (appointmentId: string) =>
  apiPost<ConnectSession>(
    `/api/connect/appointments/${appointmentId}/video/end`,
  );
